import { getHue } from '@/utils/stringHue';

import type { CalendarEvent } from '../types';

export function getEventColor(event: Pick<CalendarEvent, 'color' | 'title'>): string {
  if (event.color) return event.color;
  return `hsl(${getHue(event.title)}, 65%, 45%)`;
}
